export const environment = {
  production: false,
  baseUrl: '',
  apiUrl: '/api/v1'
};